export enum PaymentMethod {
  CARD = 'CARD',
  CASH = 'CASH',
  PAID = 'PAID',
}
